class NounPackProvider {
    static async getNounPack(pack_name: string): Promise<string[]> {
        try {
            // Fetch the JSON file from the public directory
            const response = await fetch('/noun_packs.json');
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            // Parse the JSON content
            const nounPacks = await response.json();
            
            // Return the requested pack or default to an empty array if not found
            return nounPacks[pack_name.toUpperCase()] || [];
        } catch (error) {
            // Handle possible errors
            console.error("Error fetching or parsing the JSON file:", error);
            return [];
        }
    }
}


export default NounPackProvider;